<template lang="pug">
  .static-page
    .section
      .container(v-if="content")
        .static-content( v-html="content")
      .dynamic(v-else)
        div
          .level
            .level-item.has-text-centered
              loading
    .not-found(v-if="notFound")
      .section
        .container.has-text-centered
          h1 404
          .error-message {{ gettext('PAGE NOT FOUND') }}!
</template>

<script>
import Spinner from '@/components/spinner'
import { mapGetters, mapActions } from 'vuex'
import { gettext } from './../../services/TranslateHandler'

export default {
  name: 'Static',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.receiveStaticPage({
        url: to.params[0],
        lang: vm.getLanguage
      }).then(res => {
        vm.meta.title = res.data.result.meta_title
        vm.meta.description = res.data.result.meta_description
        vm.meta.robots = res.data.result.meta_robots_tags
        vm.meta.opengraph_title = res.data.result.opengraph_title
        vm.meta.opengraph_description = res.data.result.opengraph_description
        vm.meta.opengraph_image = res.data.result.opengraph_image
        vm.meta.opengraph_type = res.data.result.opengraph_type
        vm.meta.opengraph_url = res.data.result.opengraph_url
        vm.content = res.data.result.content
        vm.notFound = false
      }).catch(() => {
        vm.meta.title = gettext('Page Not Found!')
        vm.notFound = true
        vm.content = null
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.receiveStaticPage({
      url: to.params[0],
      lang: this.getLanguage
    }).then(res => {
      this.meta.title = res.data.result.meta_title
      this.meta.description = res.data.result.meta_description
      this.meta.robots = res.data.result.meta_robots_tags
      this.meta.opengraph_title = res.data.result.opengraph_title
      this.meta.opengraph_description = res.data.result.opengraph_description
      this.meta.opengraph_image = res.data.result.opengraph_image
      this.meta.opengraph_type = res.data.result.opengraph_type
      this.meta.opengraph_url = res.data.result.opengraph_url
      this.content = res.data.result.content
      this.notFound = false
    }).catch(() => {
      this.meta.title = gettext('404 Page Not Found!')
      this.notFound = true
      this.content = null
    })
    next()
  },
  metaInfo () {
    let metaObj = {
      title: 'Bixter | ' + this.meta.title,
      meta: [
        { vmid: 'robots', name: 'robots', content: this.meta.robots },
        {itemprop: 'name', content: this.meta.title},
        {name: 'og:title', content: this.meta.opengraph_title || this.meta.meta_title},
        {name: 'description', content: this.meta.description},
        {itemprop: 'description', content: this.meta.description},
        {name: 'og:description', content: this.meta.description || this.meta.description},
        {name: 'image', content: this.meta.opengraph_image},
        {itemprop: 'image', content: this.meta.opengraph_image},
        {name: 'og:image', content: this.meta.opengraph_image},
        {vmid: 'robots', name: 'robots', content: this.meta.robots},
        {name: 'og:type', content: this.meta.opengraph_type},
        {name: 'og:url', content: this.meta.opengraph_url || document.location.origin + document.location.pathname},
        {name: 'og:site_name', content: 'Bixter.Work'},
        {name: 'og:site_name', content: window.ENV_VARIABLES.OPENGRAPH_SITE_NAME[this.getLanguage] || window.ENV_VARIABLES.OPENGRAPH_SITE_NAME.en}
      ],
      link: [
        { rel: 'canonical', href: document.location.origin + document.location.pathname }
      ]
    }
    if (window.ENV_VARIABLES.META_FACEBOOK_APP_ID) {
      metaObj.meta.push({name: 'fb:app_id', content: window.ENV_VARIABLES.META_FACEBOOK_APP_ID})
    }
    return metaObj
  },
  components: {
    'loading': Spinner
  },
  data () {
    return {
      content: null,
      notFound: false,
      meta: {
        title: '',
        robots: '',
        description: '',
        opengraph_title: '',
        opengraph_description: '',
        opengraph_image: '',
        opengraph_type: '',
        opengraph_url: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'receiveStaticPage'
    ])
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/static/index.vue